import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function Keylogger() {
  const [status, setStatus] = useState({
    bufferSize: 0,
    savedBatches: 0,
    nextSave: 120,
    isRunning: false
  });
  const [savedLogs, setSavedLogs] = useState([]);
  const [lastCaptured, setLastCaptured] = useState("");

  // Fetch status from backend
//   const fetchStatus = async () => {
//     try {
//       const response = await fetch('http://localhost:8005/');
//       const data = await response.json();
//       setStatus({
//         bufferSize: data.buffer_size || 0,
//         savedBatches: data.saved_batches || 0,
//         nextSave: Math.round(data.next_save_in || 120),
//         isRunning: true
//       });
//     } catch (error) {
//       setStatus(prev => ({ ...prev, isRunning: false }));
//     }
//   };

  // Fetch saved logs from database
  const fetchLogs = async () => {
    try {
      // Since we can't get logs from API, we'll simulate
      // In real app, you'd add a GET endpoint for logs
      const response = await fetch('http://localhost:8005/');
      const data = await response.json();
      
      // Simulate getting last saved batch
      if (data.saved_batches > savedLogs.length) {
        setSavedLogs(prev => [
          {
            id: Date.now(),
            batch: data.saved_batches,
            time: new Date().toLocaleTimeString(),
            size: data.buffer_size || 0
          },
          ...prev.slice(0, 9) // Keep last 10
        ]);
      }
    } catch (error) {
      console.log("Error fetching logs");
    }
  };

  // SINGLE API CALL every 2 minutes
  useEffect(() => {
    const callApi = setInterval(async () => {
      try {
        const response = await fetch('http://localhost:8005/log-keys', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        const result = await response.json();
        
        if (result.status === 'success') {
          setLastCaptured(`✅ ${result.saved} chars saved at ${new Date().toLocaleTimeString()}`);
        //   fetchStatus();
          fetchLogs();
        }
      } catch (error) {
        setLastCaptured(`❌ API call failed at ${new Date().toLocaleTimeString()}`);
      }
    }, 120000); // 120000ms = 2 minutes

    // Countdown timer
    const timer = setInterval(() => {
      setStatus(prev => ({
        ...prev,
        nextSave: prev.nextSave > 0 ? prev.nextSave - 1 : 120
      }));
    }, 1000);

    // Initial fetch
    // fetchStatus();
    
    // Refresh status every 5 seconds
    // const statusInterval = setInterval(fetchStatus, 5000);

    return () => {
      clearInterval(callApi);
      clearInterval(timer);
    //   clearInterval(statusInterval);
    };
  }, []);

  // Manual save button
  const manualSave = async () => {
    try {
      const response = await fetch('http://localhost:8005/log-keys', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      const result = await response.json();
      alert(result.message || "Saved successfully");
    //   fetchStatus();
    } catch (error) {
      alert("Save failed");
    }
  };

  return (
    <div className="container mt-4">
      <h1 className="text-center mb-4">🔑 Global Key Logger Monitor</h1>
      
      {/* Status Alert */}
      {/* {!status.isRunning ? (
        <div className="alert alert-danger">
          <h5>⚠️ Backend Not Running</h5>
          <p>Start the Python backend first: <code>python backend.py</code></p>
        </div>
      ) : (
        <div className="alert alert-success">
          <h5>✅ Global Key Logger Active</h5>
          <p>Capturing keys from ALL applications (browser, Notepad, Word, etc.)</p>
        </div>
      )} */}

      {/* Stats Row */}
      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card text-center">
            <div className="card-body">
              <h5>Current Buffer</h5>
              <h2 className={status.bufferSize > 0 ? "text-warning" : "text-muted"}>
                {status.bufferSize}
              </h2>
              <small>unsaved characters</small>
            </div>
          </div>
        </div>
        
        <div className="col-md-3 mb-3">
          <div className="card text-center">
            <div className="card-body">
              <h5>Saved Batches</h5>
              <h2 className="text-primary">{status.savedBatches}</h2>
              <small>in PostgreSQL</small>
            </div>
          </div>
        </div>
        
        <div className="col-md-3 mb-3">
          <div className="card text-center">
            <div className="card-body">
              <h5>Next Save</h5>
              <h2 className="text-success">{status.nextSave}s</h2>
              <div className="progress mt-2">
                <div 
                  className="progress-bar bg-success" 
                  style={{ width: `${(120 - status.nextSave) / 120 * 100}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-md-3 mb-3">
          <div className="card text-center">
            <div className="card-body">
              <h5>Status</h5>
              <h2>
                {status.isRunning ? (
                  <span className="text-success">● Active</span>
                ) : (
                  <span className="text-danger">● Stopped</span>
                )}
              </h2>
              <small>Global capture</small>
            </div>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="mb-4 text-center">
        {/* <button className="btn btn-primary me-2" onClick={fetchStatus}>
          🔄 Refresh Status
        </button> */}
        <button className="btn btn-success" onClick={manualSave}>
          💾 Save Now
        </button>
      </div>

      {/* Info Panel */}
      <div className="card mb-4">
        <div className="card-header">
          <h5 className="mb-0">📊 Monitoring Information</h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <h6>How It Works:</h6>
              <ul>
                <li>Python backend runs globally in background</li>
                <li>Captures ALL keyboard input from ANY application</li>
                <li>Frontend calls API every 2 minutes</li>
                <li>All pressed keys saved to PostgreSQL</li>
                <li>Works even when browser tab is not focused</li>
              </ul>
            </div>
            <div className="col-md-6">
              <h6>Last Activity:</h6>
              <div className="p-3 bg-light border rounded">
                {lastCaptured || "No activity yet"}
              </div>
              <p className="mt-2 mb-0">
                <small>
                  <strong>Test it:</strong> Open Notepad or Word and type something.<br/>
                  Wait 2 minutes or click "Save Now" to see it in database.
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Saved Logs */}
      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">📋 Recent Saves (Simulated)</h5>
        </div>
        <div className="card-body">
          {savedLogs.length === 0 ? (
            <p className="text-muted">No saved batches yet. First save in {status.nextSave} seconds.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Batch #</th>
                    <th>Time</th>
                    <th>Size</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {savedLogs.map(log => (
                    <tr key={log.id}>
                      <td>#{log.batch}</td>
                      <td>{log.time}</td>
                      <td>{log.size} chars</td>
                      <td>
                        <span className="badge bg-success">Saved to DB</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* PostgreSQL Instructions */}
      <div className="mt-4 p-3 bg-info text-white rounded">
        <h5>🗄️ Check PostgreSQL Data:</h5>
        <code className="d-block mt-2 p-2 bg-dark text-white">
          SELECT * FROM key_logs ORDER BY created_at DESC;
        </code>
        <code className="d-block mt-2 p-2 bg-dark text-white">
          SELECT COUNT(*), SUM(LENGTH(keys_text)) FROM key_logs;
        </code>
      </div>
    </div>
  );
}

export default Keylogger;